
import SidebarDropDownOption from '../../components/SidebarDropDownOption';
import MainMenuCard from '../../components/MainMenuCard';
import {USER_TYPE_NAME_MODEL} from "../../enums/userTypeEnum";
import {LoginOptionsApp} from "./Functionality/LoginOptionsApp";
import {STATUS_MODEL} from "../../enums/statusEnum";
import {MENU_NAME_MODEL} from "./Model/Model";
const LoginOptions = () => {

    const {
        changeStyle,
        isHovering,
        hover,
        user,
        isGuard,
        menuItemsEmployee,
        DEV,
        permission,
        setHover,
        menuItemsSupplier,
        menuItemsContractor,
        isAttendanceSupervisor
    } = LoginOptionsApp();

    return (
        <div className='overflow-hidden'>
            <div className='login_option_container'>
                <div className='login_option_header mr-0'>
                    <SidebarDropDownOption changestyle={changeStyle} hovereffect={isHovering} menutop={true} />
                </div>

                <div className='login_option_menus position-relative'>
                    <div
                        id='imageContainer'
                        className={`${hover.isMenu ? 'image-container-background-no' : 'image-container-background'
                            } image-container-transition`}
                    >
                        <div className='mask-image-background-login-1' />
                    </div>
                    <div className='overlay_mask_menu overflow-y-auto'>
                        <div className='menu_overflow_control w-100 mb-60px'>
                            {(user?.data?.userType?.name === USER_TYPE_NAME_MODEL.EMPLOYEE ||
                                user?.data?.userType?.name === USER_TYPE_NAME_MODEL.RESIDENT ||
                                    user?.data?.userType?.name === USER_TYPE_NAME_MODEL.GUARD) && (
                                <>
                                    <div className='grid-menu-icon-container full-container mx-0'>
                                        <div className='grid-menu-icon-row row mt-3 mx-3'>
                                            {user?.data?.status?.id !== STATUS_MODEL.TO_APPROVE_DOCUMENT && (
                                                <>
                                                    {
                                                        menuItemsEmployee.map(
                                                            ({
                                                                permissionKey,
                                                                permissionKeyAlt,
                                                                alwaysVisible,
                                                                navigateTo,
                                                                icon,
                                                                label,
                                                                menuName,
                                                                guardAccess,
                                                            }) => {
                                                                // Both keys open the module, so the alternative one counts as well
                                                                const permissionKeys = [permissionKey, permissionKeyAlt]
                                                                    .flat()
                                                                    .filter((key) => key !== undefined && key !== null);

                                                                return (DEV ||
                                                                    // A guard carries no permissions, its user type opens the cards of its modules
                                                                    (isGuard ? guardAccess :
                                                                    alwaysVisible ||
                                                                    (menuName === MENU_NAME_MODEL.ATTENDANCE && isAttendanceSupervisor) ||
                                                                    permission?.some((p) => permissionKeys.includes(p)))) && (
                                                                    <MainMenuCard
                                                                        key={menuName}
                                                                        isVisible={true}
                                                                        permission={permission}
                                                                        permissionCheck={permissionKey}
                                                                        navigateTo={navigateTo}
                                                                        icon={icon}
                                                                        label={label}
                                                                        hover={hover}
                                                                        setHover={setHover}
                                                                        id={'menuCard'}
                                                                    />
                                                                );
                                                            },
                                                        )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </>
                            )}
                            {user?.data?.userType?.name === USER_TYPE_NAME_MODEL.SUPPLIER_IN_CHARGE && (
                                <>
                                    <div className='grid-menu-icon-container full-container mx-0'>
                                        <div className='grid-menu-icon-row row mt-5 mx-3'>
                                            {user?.data?.status?.id !== STATUS_MODEL.TO_APPROVE_DOCUMENT && (
                                                <>
                                                    {menuItemsSupplier.map(({ navigateTo, icon, label, menuName }) => (
                                                        <MainMenuCard
                                                            key={menuName}
                                                            isVisible={true}
                                                            navigateTo={navigateTo}
                                                            icon={icon}
                                                            label={label}
                                                            hover={hover}
                                                            setHover={setHover}
                                                            permissionCheckRequired={false}
                                                            id={'menuCard'}
                                                        />
                                                    ))}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </>
                            )}
                            {user?.data?.userType?.name === USER_TYPE_NAME_MODEL.CONTRACTOR_IN_CHARGE && (
                                <>
                                    <div className='grid-menu-icon-container full-container mx-0'>
                                        <div className='grid-menu-icon-row row mt-5 mx-3'>
                                            {user?.data?.status?.id !== STATUS_MODEL.TO_APPROVE_DOCUMENT && (
                                                <>
                                                    {menuItemsContractor.map(
                                                        ({ navigateTo, icon, label, menuName }) => (
                                                            <MainMenuCard
                                                                key={menuName}
                                                                isVisible={true}
                                                                navigateTo={navigateTo}
                                                                icon={icon}
                                                                label={label}
                                                                hover={hover}
                                                                setHover={setHover}
                                                                permissionCheckRequired={false}
                                                                id={'menuCard'}
                                                            />
                                                        ),
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginOptions;
